var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2419 23.4551C30.7499 23.9319 30.5238 24.6215 30.6359 25.2978L32.3248 34.6446C32.4673 35.4368 32.1329 36.2385 31.4699 36.6963C30.8202 37.1713 29.9558 37.2283 29.2472 36.8483L20.8332 32.4599C20.5406 32.3041 20.2158 32.2205 19.8833 32.211H19.3685C19.1899 32.2376 19.0151 32.2946 18.8555 32.382L10.4396 36.7913C10.0236 37.0003 9.55245 37.0744 9.09081 37.0003C7.96615 36.7875 7.21575 35.7161 7.40003 34.5857L9.09081 25.2389C9.20289 24.5569 8.97682 23.8635 8.48479 23.3791L1.62478 16.7299C1.05106 16.1733 0.851583 15.3374 1.11375 14.5832C1.36832 13.8309 2.01803 13.2819 2.80263 13.1584L12.2444 11.7887C12.9625 11.7146 13.5932 11.2777 13.9162 10.6317L18.0766 2.10186C18.1754 1.91188 18.3027 1.7371 18.4566 1.58892L18.6276 1.45594C18.7168 1.35715 18.8194 1.27546 18.9334 1.20897L19.1405 1.13298L19.4635 1H20.2632C20.9776 1.07409 21.6064 1.50153 21.935 2.13985L26.1506 10.6317C26.4545 11.253 27.0454 11.6842 27.7274 11.7887L37.1691 13.1584C37.967 13.2724 38.6338 13.8233 38.8979 14.5832C39.1468 15.345 38.9321 16.1809 38.347 16.7299L31.2419 23.4551Z",
    fill: "#FFD600",
    stroke: "#FFD600",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Star.ff8f7528.svg";
export { ForwardRef as ReactComponent };